module.exports = __webpack_public_path__ + "img/选妃选中.f2b191f1.png";